// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__1vSkc","DesktopOnly":"Toolbar_DesktopOnly__Tiijd"};